import api from "@/api";
import { INTERVIEW_VIEW } from "./interview.const";
import { initInterviewState } from "./interview.inits";
import { client } from "./client";
import { server } from "./server";

/** @type {(import("vuex").Module<import("./interview.inits").InterviewState>)} */
export const interview = {
    namespaced: true,

    state: initInterviewState(),

    getters: {
        showsAuth(state, getters, rootState, rootGetters) {
            return 0 < rootState.interview.server.seekers.length;
        },
        showsRoom(state) {
            return state.view == INTERVIEW_VIEW.ROOM.value;
        },
        showsSeek(state) {
            return state.view == INTERVIEW_VIEW.SEEK.value;
        },
    },

    mutations: {
        setCode(state, { code }) {
            state.code = code;
        },
        setData(state, { data }) {
            state.data = data;
        },
        setView(state, { view }) {
            state.view = view;
        },
        setLoading(state, { loading }) {
            state.loading = loading;
        },
    },

    actions: {
        async getData({ state, commit }, { code }) {
            if (state.loading) return;
            else commit("setLoading", { loading: true });

            try {
                const { interview } = await api.v1.interview.get({ code });
                commit("setCode", { code });
                commit("setData", { data: interview });
            } catch (error) {
                console.error(error);
                this.$router.go(-1);
            } finally {
                commit("setLoading", { loading: false });
            }
        },
    },

    modules: {
        client,
        server,
    },
};
